import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
    <title>Logo</title>
    <g transform="translate(-8.000000, -2.000000)">
      <g transform="translate(11.000000, 5.000000)">
        <polygon
          id="Shape"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="39 0 0 22 0 67 39 90 78 68 78 23"
        />
        <path
          d="M28.5,30 L28.5,61 L35.5,61 L35.5,46.5 L46,61 L52,61 L40.5,46 L52,30 L46,30 L35.5,43.5 L35.5,30 L28.5,30 Z"
          fill="currentColor"></path>
      </g>
    </g>
  </svg>
);

export default IconLogo;
